import type { ParseKeys } from 'i18next';

// `messageKey` points into the `auth` catalogue. The rule is a module-level constant, so it
// cannot hold the translated text; the component calls `t(messageKey)` while rendering.
export const passwordRules: { regex: RegExp; messageKey: ParseKeys<'auth'> }[] = [
  { regex: /.{8,}/, messageKey: 'passwordRules.minLength' },
  { regex: /[A-ZĄĆĘŁŃÓŚŹŻ]/, messageKey: 'passwordRules.uppercaseExtended' },
  {
    regex: /[!@#$%^&*()\[\]{}\\|;:'",.<>/?`~_\-=+]/,
    messageKey: 'passwordRules.special',
  },
  { regex: /\d/, messageKey: 'passwordRules.number' },
];
